import { NoopLogger } from "./NoopLogger";
import { ConsoleLogger } from "./ConsoleLogger";
/**
 * Class that wraps the external ULS logger
 */
var UlsLoggerWrapper = /** @class */ (function () {
    function UlsLoggerWrapper() {
        this.externalLogger = process.env.NODE_ENV !== "production"
            ? new ConsoleLogger()
            : new NoopLogger();
    }
    UlsLoggerWrapper.prototype.setCorrelationId = function (id) {
        this.externalLogger.setCorrelationId(id);
    };
    UlsLoggerWrapper.prototype.setLogger = function (logger) {
        this.externalLogger = logger;
    };
    UlsLoggerWrapper.prototype.sendTraceTag = function (tag, category, level, message) {
        this.externalLogger.sendTraceTag(tag, category, level, message);
    };
    UlsLoggerWrapper.prototype.debugAssertTag = function (tag, category, condition, message) {
        this.externalLogger.debugAssertTag(tag, category, condition, message);
    };
    UlsLoggerWrapper.prototype.shipAssertTag = function (tag, category, condition, message) {
        this.externalLogger.shipAssertTag(tag, category, condition, message);
    };
    return UlsLoggerWrapper;
}());
export { UlsLoggerWrapper };
/**
 * Instance of UlsLogger that can be set by the consumer
 */
export var ULS = new UlsLoggerWrapper();
/**
 * Sets the logger instance.
 *
 * @param {Logger} logger
 */
export function initializeLogger(logger) {
    if (!logger) {
        throw new Error("The 'logger' argument is missing");
    }
    ULS.setLogger(logger);
}
//# sourceMappingURL=externalLogger.js.map